import { render, staticRenderFns } from "./SysMessageTemplateModal.vue?vue&type=template&id=b4197794&scoped=true&"
import script from "./SysMessageTemplateModal.vue?vue&type=script&lang=js&"
export * from "./SysMessageTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4197794",
  null
  
)

export default component.exports